var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStudent(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2085_57134)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.28076 6.78307C7.3519 6.93657 7.58182 7.03321 7.68788 7.06234L7.78445 6.3772C7.72025 6.39934 7.52963 6.51151 7.28076 6.78307Z",
    fill: "#555555"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.563 6.78307C16.4918 6.93657 16.2619 7.03321 16.1559 7.06234L16.0593 6.3772C16.1235 6.39934 16.3141 6.51151 16.563 6.78307Z",
    fill: "#555555"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8699 12.4792H9.16943V18.9535H14.8699V12.4792Z",
    fill: "#E7A484"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5186 16.2896C10.5749 16.0901 9.73813 15.3379 9.17188 14.2578V13.21L12.0208 13.3704L14.8697 13.21V14.2578C14.3034 15.3379 13.4666 16.0901 12.523 16.2896C12.3933 16.3172 12.261 16.3342 12.1265 16.34C12.125 16.3401 12.1234 16.3401 12.1218 16.3402C12.0541 16.3431 11.9867 16.343 11.9197 16.3402C11.9181 16.3401 11.9166 16.3401 11.915 16.34C11.7806 16.3342 11.6483 16.3172 11.5186 16.2896Z",
    fill: "#A65444"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0025 8.45257C16.7217 7.78198 16.1481 8.11212 16.1481 8.11212C16.4805 5.06694 14.9284 3.05688 12.0205 3.05688C9.11254 3.05688 7.56038 5.06694 7.89114 8.11212C7.89114 8.11212 7.31748 7.7837 7.03668 8.45257C6.75588 9.12316 7.26925 10.693 7.58622 11.1934C7.9032 11.692 8.4648 11.5751 8.4648 11.5751C8.4648 11.5751 8.50098 12.6309 8.64741 13.0212C8.79384 13.4115 9.81368 15.7586 12.0187 15.7586C14.2238 15.7586 15.2436 13.4115 15.3901 13.0212C15.5365 12.6309 15.5727 11.5321 15.5727 11.5321C15.5727 11.5321 16.1343 11.6938 16.4513 11.1934C16.7682 10.6948 17.2816 9.12316 17.0008 8.45257H17.0025Z",
    fill: "#E7A484"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.47633 10.7585L8.34766 10.7671L8.40194 11.5786L8.53062 11.57L8.47633 10.7585Z",
    fill: "#C46966"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.575 10.7583L15.5137 11.5261L15.6422 11.5364L15.7036 10.7685L15.575 10.7583Z",
    fill: "#C46966"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.41889 9.96375C7.23319 9.24845 7.26242 8.80999 7.51002 8.5813L7.59771 8.67587C7.39138 8.86673 7.37246 9.27596 7.54441 9.93108L7.41889 9.96375Z",
    fill: "#C46966"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.651 9.96375L16.5255 9.93108C16.6957 9.27596 16.6785 8.86501 16.4722 8.67587L16.5599 8.5813C16.8092 8.80999 16.8384 9.24845 16.651 9.96375Z",
    fill: "#C46966"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7341 5.27819C14.6574 4.40986 14.5541 3.54497 13.722 3.33347C13.2224 3.15293 12.6539 3.05664 12.02 3.05664C10.0423 3.05664 8.40526 3.60526 8.1503 5.47775C7.48368 5.73151 7.66784 6.56663 7.76543 8.06282C7.76543 8.06282 7.77158 8.05351 7.89065 8.11187C8.27482 8.36119 8.36268 9.04038 8.30238 9.7127C9.16546 9.71785 8.51255 6.93748 9.18957 6.26345C11.753 7.87459 15.1725 7.02517 15.1725 7.02517C15.269 8.07404 15.1277 9.71441 15.7341 9.7127C15.6738 9.06961 15.6721 8.36635 16.1459 8.11187C16.2113 7.50146 16.201 6.93404 16.1217 6.41648C16.4215 6.13621 15.7117 6.01584 15.7341 5.53611V5.27819Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2932 18.8232C17.5605 16.9432 14.8972 16.2773 14.8972 16.2773C13.5309 18.4755 10.3613 18.5076 9.15275 16.2773C9.15275 16.2773 6.48251 16.9432 3.74985 18.8232C-0.764395 21.9288 8.51814 25.9981 12.0224 25.9981C15.5267 25.9981 24.4437 22.1434 20.2949 18.8232H20.2932Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.05176 6.83616V3.77905H5.95035V6.83616H5.05176Z",
    fill: "#FD9500"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 5.51529,
    cy: 7.12609,
    rx: 0.898592,
    ry: 0.673944,
    fill: "#FD9500"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6841 1.92909L5.01433 3.35179C4.53804 3.45338 4.54008 4.13381 5.01697 4.23254L7.17818 4.67999H16.517L18.7487 4.23284C19.2293 4.13654 19.2314 3.45014 18.7514 3.35092L11.869 1.9285C11.808 1.91589 11.745 1.91609 11.6841 1.92909Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5634 6.79042C12.1574 5.19441 9.18861 6.43179 7.27344 6.79042V4.67993H16.5634C16.551 5.01097 16.5336 5.89651 16.5634 6.79042Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2085_57134"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudent);
export default __webpack_public_path__ + "static/media/student.b9ecfbfcbcae340a9c56014fb2837ab0.svg";
export { ForwardRef as ReactComponent };